// Phone-only back button for the floating product-page buttons (see
// assets/component-pdp-floating-nav.css). Goes back in history when the
// visitor came from this site, otherwise to the home page (a link opened
// from an ad or another app has nothing sensible to go back to).
( function () {

	if ( window.__pdpFloatingNav ) return;
	window.__pdpFloatingNav = true;

	const data = document.currentScript ? document.currentScript.dataset : {};
	const label = data.backLabel || 'Back';
	const logoSrc = data.logo;
	const logoLabel = data.logoLabel || '';

	function init() {
		if ( document.querySelector('.pdp-float-back, .pdp-float-logo') ) return;
		const button = document.createElement('button');
		button.type = 'button';
		button.className = 'pdp-float-back';
		button.setAttribute('aria-label', label);
		button.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M12.5 4L6.5 10l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		button.addEventListener('click', () => {
			let sameSite = false;
			try { sameSite = !! document.referrer && new URL(document.referrer).origin === location.origin; } catch ( e ) {}
			if ( sameSite && history.length > 1 ) history.back();
			else location.href = ( window.Shopify && Shopify.routes && Shopify.routes.root ) || '/';
		});
		document.body.appendChild(button);

		// Logo in the same floating style, next to the back button.
		if ( logoSrc ) {
			const logo = document.createElement('a');
			logo.className = 'pdp-float-logo';
			logo.href = ( window.Shopify && Shopify.routes && Shopify.routes.root ) || '/';
			logo.setAttribute('aria-label', logoLabel);
			const img = new Image();
			img.src = logoSrc;
			img.alt = '';
			logo.appendChild(img);
			document.body.appendChild(logo);
		}
	}

	if ( document.readyState === 'loading' ) document.addEventListener('DOMContentLoaded', init);
	else init();

} )();
